export default __webpack_public_path__ + "static/media/hostImgM2.75dd40f8.jpg";